export const COMPANY_ID =
  process.env.NODE_ENV === "production"
    ? "63a031ff6c71cfeec81f1533"
    : "63a03b73195869f81c88b5e3";
